module.exports = __webpack_public_path__ + "img/juzhan-mini.e6d314f.jpg";